module.exports = __webpack_public_path__ + "img/vertical_bar_base.1f531f62.svg";